import { type OpenApiSchemaStoreType } from '../../api/schema';

/** Kit - обычный магазин на платформе KIT */
export const STORE_TYPE_KIT = 'Kit' satisfies OpenApiSchemaStoreType;
/** RemoteORM - кастомное решение для селлера, использующее на фронтенде поведение Kit */
export const STORE_TYPE_REMOTE_ORM = 'RemoteORM' satisfies OpenApiSchemaStoreType;
/** Bitrix - внешний чекаут со способом подключения YCP для битрикса */
export const STORE_TYPE_BITRIX = 'Bitrix' satisfies OpenApiSchemaStoreType;
/** YCP - внешний чекаут со способом подключения YCP */
export const STORE_TYPE_YCP = 'YCP' satisfies OpenApiSchemaStoreType;
/** Lite - KIT-Lite - магазин без витрины, к примеру для покупки через поиск + Алиса */
export const STORE_TYPE_LITE = 'Lite' satisfies OpenApiSchemaStoreType;
